import { render, staticRenderFns } from "./AlipayInfo.vue?vue&type=template&id=64cd8d30&scoped=true"
import script from "./AlipayInfo.vue?vue&type=script&lang=js"
export * from "./AlipayInfo.vue?vue&type=script&lang=js"
import style0 from "./AlipayInfo.vue?vue&type=style&index=0&id=64cd8d30&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64cd8d30",
  null
  
)

export default component.exports